module.exports = __webpack_public_path__ + "static/img/A77.2f834b3a.jpg";